import { useTranslation } from 'react-i18next'
import Button from '../ui/Button'
import RichText from '../ui/RichText'
import contentData from '../../data/content.json'

function GentleYoga() {
  const { t } = useTranslation()

  const formatItems = t('pages.home.sections.gentleYoga.format.items', { returnObjects: true })
  const scheduleItems = t('pages.home.sections.gentleYoga.schedule.items', { returnObjects: true })
  const benefitsItems = t('pages.home.sections.gentleYoga.benefits.items', { returnObjects: true })

  return (
    <section id="gentle-yoga" className="section-container bg-white py-80">
      <div className="content-wrapper">
        <h2 className="text-lato-bold text-[32px] mb-32">
          {t('pages.home.sections.gentleYoga.heading')}
        </h2>

        {/* Two-column layout: Intro+Format left, Schedule+Benefits right */}
        <div className="flex flex-col desktop:flex-row gap-32 desktop:gap-40 mb-32">
          {/* Left column - Intro & Format */}
          <div className="desktop:w-1/2">
            <RichText
              text={t('pages.home.sections.gentleYoga.intro')}
              className="text-lato-regular mb-24"
            />

            {/* Format details */}
            <RichText
              text={t('pages.home.sections.gentleYoga.format.text')}
              className="text-lato-regular mb-12"
            />
            <ul className="space-y-5">
              {formatItems.map((item, index) => (
                <li key={index} className="text-lato-regular flex items-start gap-12">
                  <span className="text-sage mt-1 flex-shrink-0">*</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right column - Schedule & Benefits boxes */}
          <div className="desktop:w-1/2 flex flex-col gap-24">
            {/* Schedule box */}
            <div className="bg-sage/10 rounded-md p-24">
              <h3 className="text-lato-bold text-xl">
                {t('pages.home.sections.gentleYoga.schedule.heading')}
              </h3>
              <ul className="space-y-12">
                {scheduleItems.map((item, index) => (
                  <li key={index} className="text-lato-regular flex items-start gap-12">
                    <span className="text-sage mt-1 flex-shrink-0">&#8594;</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Benefits box */}
            <div className="bg-beige rounded-md p-24">
              <h3 className="text-lato-bold text-xl">
                {t('pages.home.sections.gentleYoga.benefits.heading')}
              </h3>
              <ul className="space-y-12">
                {benefitsItems.map((item, index) => (
                  <li key={index} className="text-lato-regular flex items-start gap-12">
                    <span className="text-sage mt-1 flex-shrink-0">&#10003;</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <Button
          href={contentData.contactForm.url}
          openInNewTab={contentData.contactForm.openInNewTab}
          className="max-w-[220px]"
        >
          {t('pages.home.sections.gentleYoga.ctaButton.text')}
        </Button>
      </div>
    </section>
  )
}

export default GentleYoga
